import { render, staticRenderFns } from "./TokenStoreFullscreen.vue?vue&type=template&id=56bbe5d3&scoped=true"
import script from "./TokenStoreFullscreen.vue?vue&type=script&lang=js"
export * from "./TokenStoreFullscreen.vue?vue&type=script&lang=js"
import style0 from "./TokenStoreFullscreen.vue?vue&type=style&index=0&id=56bbe5d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbe5d3",
  null
  
)

export default component.exports